import { Ellipse } from '../../utils/editorReactIcons';
export { Ellipse };
export default Ellipse;
